<template>
    <div class="privacy-page-container hidden-first">
        <div class="info-inner-container">
            <section class="container">
                <div class="row-custom">
                    <div class="team-col privacy-block-first">
                        <h1>Privacyverklaring Tandzorg Gestel</h1>
                        <p>
                            Uw privacy is voor ons van groot belang. Tandzorg Gestel gaat zorgvuldig en vertrouwelijk om met uw persoonsgegevens en handelt daarbij volgens de geldende wet- en regelgeving op het gebied van privacy, waaronder de Algemene Verordening Gegevensbescherming (AVG). In deze privacyverklaring informeren wij u over hoe wij met uw gegevens omgaan.
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Categorieën persoonsgegevens</h3>
                        <p>
                            Bij het gebruik van onze website en onze diensten kunt u persoonsgegevens aan ons verstrekken. Dit gebeurt ook tijdens uw bezoek aan onze praktijk in het kader van de behandelovereenkomst. Wij verzamelen en verwerken uitsluitend de gegevens die u zelf actief aan ons verstrekt of waarvan het duidelijk is dat deze aan ons worden doorgegeven om te verwerken. Dit kunnen onder andere de volgende gegevens zijn:
                            <ul class="when-to-contact-list">
                                <li>
                                    NAW-gegevens (naam, adres, woonplaats)
                                </li>
                                <li>
                                    Burgerservicenummer (BSN)
                                </li>
                                <li>
                                    Geslacht
                                </li>
                                <li>
                                    E-mailadres
                                </li>
                                <li>
                                    Telefoonnummer(s)
                                </li>
                                <li>
                                    Gegevens over uw gezondheid
                                </li>
                                <li>
                                    Naam en polisnummer van uw zorgverzekeraar
                                </li>
                                <li>
                                    Naam van uw andere zorgverleners, zoals uw huisarts of specialist
                                </li>
                                <li>
                                    Tijdstip van uw afspraak
                                </li>
                                <li>
                                    Betalingsgegevens
                                </li>
                            </ul>
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Doeleinden van gegevensverwerking</h3>
                        <p>
                            Wij gebruiken uw persoonsgegevens uitsluitend voor de volgende doeleinden:
                            <ul class="when-to-contact-list">
                                <li>
                                    Het aanmaken van een patiëntenkaart en inschrijving bij de praktijk
                                </li>
                                <li>
                                    Het bijhouden van uw medisch dossier
                                </li>
                                <li>
                                    Het plannen van afspraken
                                </li>
                                <li>
                                    Het uitvoeren van behandelingen
                                </li>
                                <li>
                                    Het beantwoorden van uw vragen per e-mail
                                </li>
                                <li>
                                    Het bijhouden van uw voorkeuren
                                </li>
                                <li>
                                    Het verbeteren van onze dienstverlening
                                </li>
                                <li>
                                    Het uitvoeren van overige diensten op uw verzoek
                                </li>
                                <li>
                                    Het beveiligd versturen van uw tandheelkundige gegevens aan externe zorgverleners indien nodig
                                </li>
                            </ul>
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Grondslag van gegevensverwerking</h3>
                        <p>
                            Wij verwerken uw persoonsgegevens omdat dit noodzakelijk is voor de uitvoering van de behandelovereenkomst tussen u en Tandzorg Gestel (artikel 6 lid 1 sub b AVG). Daarnaast kunnen wij uw gegevens verwerken voor een gerechtvaardigd belang, zoals het informeren over wijzigingen in onze dienstverlening (artikel 6 lid 1 sub f AVG).
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Verstrekking van persoonsgegevens aan derden</h3>
                        <p>
                            Uw persoonsgegevens worden alleen met derden gedeeld als dit noodzakelijk is voor de uitvoering van de behandelovereenkomst of wanneer wij daartoe wettelijk verplicht zijn. In alle andere gevallen vragen wij eerst uw toestemming.
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Bewaartermijnen</h3>
                        <p>
                            Uw medische gegevens bewaren wij conform de wettelijke bewaartermijn van 15 jaar volgens de Wet op de geneeskundige behandelovereenkomst (WGBO). Andere gegevens, zoals betalingsgegevens, worden ook maximaal 15 jaar bewaard, tenzij de wet een andere termijn voorschrijft.
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Beveiliging van gegevens</h3>
                        <p>
                            Wij nemen passende beveiligingsmaatregelen om uw persoonsgegevens te beschermen. Onze praktijk werkt met software die voldoet aan de NEN7510-normen voor informatiebeveiliging en er is een intern privacybeleid van kracht. Daarnaast beschikken wij over verwerkersovereenkomsten met derde partijen die gegevens verwerken in opdracht van onze praktijk.
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Cookies</h3>
                        <p>
                            Onze website maakt gebruik van technische, functionele en analytische cookies die geen inbreuk maken op uw privacy. Deze cookies zorgen voor een goede werking van de website en optimaliseren uw gebruikerservaring. U kunt uw browserinstellingen aanpassen om het opslaan van cookies te voorkomen.
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Uw rechten</h3>
                        <p>
                            U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te laten verwijderen. Ook kunt u bezwaar maken tegen de verwerking van uw gegevens of uw toestemming intrekken. Verzoeken kunnen worden ingediend via e-mail (<a href="mailto:info@tandzorggestel.nl" class="contact-link">info@tandzorggestel.nl</a>) of telefonisch (<a href="tel:+31735515644" class="contact-link">0735515644</a>). Wij streven ernaar om binnen 21 werkdagen te reageren.
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Klacht indienen</h3>
                        <p>
                            Bent u niet tevreden over hoe wij met uw gegevens omgaan? U kunt een klacht indienen bij de Autoriteit Persoonsgegevens via hun website: <a href="https://autoriteitpersoonsgegevens.nl" target="_blank">https://autoriteitpersoonsgegevens.nl</a>.
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Wijzigingen</h3>
                        <p>
                            Wij behouden ons het recht voor om deze privacyverklaring aan te passen. Eventuele wijzigingen worden via onze website gecommuniceerd. Wij adviseren u daarom om deze verklaring regelmatig te raadplegen.
                        </p>
                    </div>
                    <div class="team-col privacy-block">
                        <h3>Contactgegevens</h3>
                        <p>
                            Tandzorg Gestel<br>
                            Email: <a href="mailto:info@tandzorggestel.nl" class="contact-link">info@tandzorggestel.nl</a><br>
                            Telefoonnummer: <a href="tel:+31735515644" class="contact-link">0735515644</a>
                        </p>
                    </div>
                </div>
            </section>
        </div>
</div>
</template>

<script>
export default {
    name: "Privacy",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show-first')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden-first')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Privacy Policy - Tandzorg Gestel"
      // document.querySelector('meta[name="description"]').setAttribute("content", "Over ons website Milad");
      this.$store.commit('updateActivePage', '')
    }
}

</script>

<style scoped>
.hidden-first {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}
.show-first {
  opacity: 1;
  transform: translateX(0);
}
.privacy-page-container {
  margin-top: 130px;
}
.row-custom {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    margin-bottom: 0px;
}
.second-row-custom {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    margin-bottom: 0px;
}
.team-col {
    flex-basis: 100%;
}
.row-custom .image-col-right{
  display: flex;
  justify-content: center;
}
.team-col img {
    width: 100%;
    max-width: 600px;
}
.team-col h1 {
    padding-top: 0;
}
.team-col p {
    padding: 5px 0 0;
    /* background-color: red; */
    font-size: 1.4rem;
}
#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
}

.second-info-container {
    /* background-color: red; */
    padding: 0rem 2rem 6rem 2rem;
    margin-top: -50px;
}

.when-to-contact-list {
    /* background-color: pink; */
    padding: 0;
    padding-left: 13px;
    font-size: 1.4rem;
    margin-top: 20px;
    margin-bottom: 13px;
    list-style: none;
    list-style-type: disc;
}
.when-to-contact-list li{
    /* background-color: red; */
    padding-left: 3px;
    margin-bottom: 10px;
}
.evening-service {
    margin-top:-5px;
    margin-left: 3px;

}
.last-sentence {
    /* background-color: red; */
    margin-top: -5px;
}
.location-par {
    /* background-color: red; */
    margin-left: 3px;
}
.opening-hours-par {
    margin-top: 6px;
    margin-left: 3px;
}

.privacy-block {
    margin-bottom: -5px;
}
.privacy-block-first {
    margin-bottom: -5px;
}

@media(max-width: 991px) {
    .privacy-page-container {
    margin-top: 80px;
    }
    .row-custom {
        display: flex;
        flex-direction: column;
         row-gap: 0px; 
         margin-bottom: 20px;
    }
    .second-row-custom {
        display: flex;
        flex-direction: column;
         row-gap: 20px; 
         margin-bottom: 20px;
    }
    h1 {
        font-size: 20px;
    }
    .privacy-block {
        margin-top:20px;
    }
    .team-col img {
        max-width: 100%;
    }

    .team-col p {
        padding: 7px 0px 0px;
    }

    #the-practice-img {
        height: 200px;
    }

    .second-info-container {
    padding: 0rem 2rem 0rem 2rem;
    }
    .second-info-container {
        margin-top: -25px;
    }

}

</style>